"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arena = {
  id: "arena",
  title: {
    en: "Arena territory",
    de: "Arena Gebiet"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Arena territory"), /*#__PURE__*/_react.default.createElement("p", null, "Grand wizards made a portal between cities in Idios continent, but they made a gate even to the evil dark wizards Kilton."), /*#__PURE__*/_react.default.createElement("p", null, "These gates are found in rural areas of Idios, when you are exploring you must be careful."), /*#__PURE__*/_react.default.createElement("p", null, "Only few gates were found that are linking between Irena and Idios. For some unknown reason dark wizards are continually creating these gates."))
  }
};
var _default = arena;
exports.default = _default;